export default "__VITE_ASSET__CWro8zy$__"